import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { motion, AnimatePresence } from "framer-motion";

export const FAQSection = () => {
  const faqs = [
    {
      question: "How long does it take to create a montage?",
      answer: "Typically, we deliver your montage within 1-2 weeks after order confirmation and receipt of all materials."
    },
    {
      question: "What format should I provide my photos and videos in?",
      answer: "We accept most common photo formats (JPG, PNG) and video formats (MP4, MOV). Higher resolution files will result in better quality output."
    },
    {
      question: "How many photos can I include?",
      answer: "The number of photos depends on your chosen package. Our Basic package includes up to 100 photos, while higher tiers offer more capacity or unlimited photos."
    },
    {
      question: "Can I choose my own music?",
      answer: "Yes! You can provide your own music or select from our licensed music library. Please ensure you have the rights to any music you provide."
    },
    {
      question: "What resolution options are available?",
      answer: "We offer various resolution options from 1080p up to 8K, depending on your package. Higher resolutions are available as upgrades."
    }
  ];

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-navy-800 mb-4">Frequently Asked Questions</h2>
          <p className="text-gray-600">Find answers to common questions about our montage services</p>
        </motion.div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left text-navy-800 hover:text-navy-600">
                {faq.question}
              </AccordionTrigger>
              <AnimatePresence>
                <AccordionContent>
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                    className="text-gray-600"
                  >
                    {faq.answer}
                  </motion.div>
                </AccordionContent>
              </AnimatePresence>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};